var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-splitter", {
    attrs: { "use-bottom": _vm.useBottom },
    model: {
      value: _vm.height,
      callback: function ($$v) {
        _vm.height = $$v
      },
      expression: "height",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }